import { Reducer } from 'redux'
import { IKlantGroepState } from '../interfaces'
import { KlantGroepActions, Actions } from '../actions/klantGroepenAction'

const initialState: IKlantGroepState = {
  loading: false,
  selectie: { code: undefined, vestiging: undefined },
  foutmelding: undefined,
  klantGroepen: undefined,
  locaties: [],
  locatieSelectie: { locatieGln: undefined, locatieNaam: undefined },
}

export const klantGroepenReducer: Reducer<
  IKlantGroepState,
  KlantGroepActions
> = (state = initialState, action) => {
  switch (action.type) {
    case Actions.GetKlantGroepRequest:
      return {
        ...state,
        loading: true,
        selectie: action.payload,
        foutmelding: null,
      }
    case Actions.GetKlantGroepResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.errorMessage,
        klantGroepen: action.success ? action.payload : [],
      }
    case Actions.PostKlantGroepRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.PostKlantGroepResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
      }
    case Actions.DeleteKlantGroepRequest:
      return { ...state, loading: true, foutmelding: null }
    case Actions.DeleteKlantGroepResponse:
      return {
        ...state,
        loading: false,
        foutmelding: action.success ? action.payload : action.errorMessage,
      }
    default:
      // The following line guarantees that every action in the KnownAction union has been covered by a case above
      neverReached(action)
  }
  return state
}

// tslint:disable-next-line:no-empty
const neverReached = (never: never) => {}
